export const PicturePerfectLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="Picture_Perfect_Badge_-_Locked"
      data-name="Picture Perfect Badge - Locked"
      transform="translate(1 -5)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          fill="#e6e6e6"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
      <g
        id="Camera_-_L"
        data-name="Camera - L"
        transform="translate(11.104 17)"
      >
        <path
          id="Camera_-_L-2"
          data-name="Camera - L"
          d="M23.127,9.937a.823.823,0,0,0,.821-.825V6.86a.823.823,0,0,0-.821-.825H20.889a.823.823,0,0,0-.821.825V9.116a.823.823,0,0,0,.821.825Zm2.641,1.576a.613.613,0,0,0-.612.615V23.613a1.646,1.646,0,0,1-1.643,1.65H3.475a1.646,1.646,0,0,1-1.643-1.65V12.127a.616.616,0,1,0-1.232,0V23.613A2.881,2.881,0,0,0,3.475,26.5H23.517a2.881,2.881,0,0,0,2.875-2.887V12.127a.613.613,0,0,0-.624-.615ZM15.55,13.22a.613.613,0,0,0,.6.511h.1a.61.61,0,0,0,.526-.714,3.2,3.2,0,0,0-3.162-2.681.619.619,0,0,0,0,1.237A1.982,1.982,0,0,1,15.55,13.22Zm3.569.173A5.635,5.635,0,1,0,13.5,18.948a5.605,5.605,0,0,0,5.639-5.556Zm-10.058,0A4.416,4.416,0,1,1,13.5,17.727a4.383,4.383,0,0,1-4.419-4.335ZM23.517,3.181H18.063L17.4,1.407h0A1.233,1.233,0,0,0,16.3.5H10.7a1.233,1.233,0,0,0-1.1.907L8.929,3.181H6.683v-.6A1.1,1.1,0,0,0,5.652,1.424H4.3A1.1,1.1,0,0,0,3.274,2.583v.6A2.882,2.882,0,0,0,.616,6.039v4.153a.616.616,0,1,0,1.232,0V6.039a1.646,1.646,0,0,1,1.643-1.65H23.517a1.646,1.646,0,0,1,1.643,1.65v4.153a.616.616,0,1,0,1.232,0V6.039a2.881,2.881,0,0,0-2.875-2.858Z"
          transform="translate(-0.6 -0.5)"
          fill="#666"
        />
      </g>
    </g>
  </svg>
);

export const PicturePerfectUnLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Picture_Perfect_Badge_-_Unlocked"
      data-name="Picture Perfect Badge - Unlocked"
      transform="translate(1)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
      </g>
      <g id="Group_2669" data-name="Group 2669" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
      <g
        id="Camera_-_L"
        data-name="Camera - L"
        transform="translate(11.104 17)"
      >
        <path
          id="Camera_-_L-2"
          data-name="Camera - L"
          d="M23.127,9.937a.823.823,0,0,0,.821-.825V6.86a.823.823,0,0,0-.821-.825H20.889a.823.823,0,0,0-.821.825V9.116a.823.823,0,0,0,.821.825Zm2.641,1.576a.613.613,0,0,0-.612.615V23.613a1.646,1.646,0,0,1-1.643,1.65H3.475a1.646,1.646,0,0,1-1.643-1.65V12.127a.616.616,0,1,0-1.232,0V23.613A2.881,2.881,0,0,0,3.475,26.5H23.517a2.881,2.881,0,0,0,2.875-2.887V12.127a.613.613,0,0,0-.624-.615ZM15.55,13.22a.613.613,0,0,0,.6.511h.1a.61.61,0,0,0,.526-.714,3.2,3.2,0,0,0-3.162-2.681.619.619,0,0,0,0,1.237A1.982,1.982,0,0,1,15.55,13.22Zm3.569.173A5.635,5.635,0,1,0,13.5,18.948a5.605,5.605,0,0,0,5.639-5.556Zm-10.058,0A4.416,4.416,0,1,1,13.5,17.727a4.383,4.383,0,0,1-4.419-4.335ZM23.517,3.181H18.063L17.4,1.407h0A1.233,1.233,0,0,0,16.3.5H10.7a1.233,1.233,0,0,0-1.1.907L8.929,3.181H6.683v-.6A1.1,1.1,0,0,0,5.652,1.424H4.3A1.1,1.1,0,0,0,3.274,2.583v.6A2.882,2.882,0,0,0,.616,6.039v4.153a.616.616,0,1,0,1.232,0V6.039a1.646,1.646,0,0,1,1.643-1.65H23.517a1.646,1.646,0,0,1,1.643,1.65v4.153a.616.616,0,1,0,1.232,0V6.039a2.881,2.881,0,0,0-2.875-2.858Z"
          transform="translate(-0.6 -0.5)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
